/* Costify mobile — bottom sheets, wishlist, qty steppers. Active on all viewports; harmless on desktop (shell hidden). */
(function () {
  'use strict';

  /* ---------- Bottom sheets ---------- */
  function openSheet(id) {
    var sheet = document.getElementById(id);
    if (!sheet) return;
    var backdrop = document.querySelector('.cm-sheet-backdrop[data-for="' + id + '"]');
    if (backdrop) backdrop.classList.add('is-open');
    sheet.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeSheet(sheet) {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    var backdrop = document.querySelector('.cm-sheet-backdrop[data-for="' + sheet.id + '"]');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cm-open]');
    if (opener) { e.preventDefault(); openSheet(opener.getAttribute('data-cm-open')); return; }
    var closer = e.target.closest('[data-cm-close]');
    if (closer) { e.preventDefault(); closeSheet(closer.closest('.cm-sheet')); return; }
    var backdrop = e.target.closest('.cm-sheet-backdrop');
    if (backdrop) {
      backdrop.classList.remove('is-open');
      var s = document.getElementById(backdrop.getAttribute('data-for'));
      if (s) s.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ---------- Wishlist (localStorage) ---------- */
  var KEY = 'cm_wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function setWish(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function paintHearts() {
    var w = getWish();
    document.querySelectorAll('[data-cm-wish]').forEach(function (b) {
      b.classList.toggle('is-on', w.indexOf(b.getAttribute('data-cm-wish')) !== -1);
    });
    document.querySelectorAll('[data-cm-wishcount]').forEach(function (el) {
      el.textContent = w.length;
    });
  }
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-cm-wish]');
    if (!heart) return;
    e.preventDefault(); e.stopPropagation();
    var id = heart.getAttribute('data-cm-wish');
    var w = getWish(); var i = w.indexOf(id);
    if (i === -1) w.push(id); else w.splice(i, 1);
    setWish(w); paintHearts();
  });
  document.addEventListener('DOMContentLoaded', paintHearts);
  paintHearts();
})();
